<script>
import { mapActions } from 'vuex'

const EMIT_USER_EVENT = 'user-event'
const EMIT_SYSTEM_EVENT = 'system-event'

export default {
  created () {
    this.$globalEvent.addEventListener(EMIT_USER_EVENT, this.onUserEvent)
    this.$globalEvent.addEventListener(EMIT_SYSTEM_EVENT, this.onSystemEvent)
  },

  beforeDestroy () {
    this.$globalEvent.removeEventListener(EMIT_USER_EVENT, this.onUserEvent)
    this.$globalEvent.removeEventListener(EMIT_SYSTEM_EVENT, this.onSystemEvent)
  },

  methods: {
    onUserEvent (event) {
      if (event.event === 'user-updated') {
        this.getUser()
      }
    },

    onSystemEvent (event) {
      if (event.event === 'clear-cache') {
        this.getUser()
      } else if (event.event === 'users-updated') {
        const currentUserId = this.$store.state.User.user.id
        if (event?.data?.userIds?.includes(currentUserId)) {
          this.getUser()
        }
      }
    },

    ...mapActions(['getUser'])
  },

  render () {
    return null
  }
}
</script>
